<template>
  <v-reports
    v-if="access.report_debt"
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  ></v-reports>
  <error404 v-else></error404>
</template>
<script>
export default {
  name: "ReportsDebts",
  data: () => ({
    headers: [
      {
        text: "Receipt no.",
        value: "receipt_no",
        available: true,
        disabled: true,
      },
      { text: "Date", value: "given_time", available: true },
      { text: "Donator", value: "donator", available: true },
      { text: "Accepted time", value: "accepted_time", available: true },
      { text: "Receiver", value: "receiver", available: true },
      { text: "Total", value: "total", available: true },
      { text: "Charged", value: "is_charged", available: true, disabled: true },
    ],
    data: [],
    params: {},
    page: 1,
    numPages: 1,
    data_loading: false,
    access: null,
  }),
  methods: {
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    myfunc() {
      this.update();
    },
    async update(params) {
      this.data_loading = true;
      this.params = params;
      var start_date = new Date(params.start_date).getTime();
      var end_date = new Date(params.end_date).getTime();
      var taxes = this.$communicator.then(
        this,
        await this.$communicator("by_debt", {
          arguments: [start_date, end_date, 10, this.page],
          params: {
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees: params.employee._id != "" ? [params.employee._id] : [],
          },
        })
      );
      for (let i = 0; i < taxes.data.length; i++) {
        taxes.data[i].total = Math.round(taxes.data[i].total).toLocaleString();
        var time = new Date(taxes.data[i].given_time);
        taxes.data[i].given_time =
          time.getDate() + "/" + (time.getDay() + 1) + "/" + time.getFullYear();
        if (taxes.data[i].accepted_time) {
          var accepted_time = new Date(taxes.data[i].accepted_time);
          taxes.data[i].accepted_time =
            accepted_time.getDate() +
            "/" +
            (accepted_time.getDay() + 1) +
            "/" +
            accepted_time.getFullYear();
        }

        taxes.data[i].type = taxes.data[i].is_refund ? "refund" : "sale";
      }
      this.data_loading = false;
      this.data = taxes.data;
      this.numPages = taxes.page;
    },
  },
  mounted() {
    this.headers = [
      {
        text: this.$t(`receipt_no`),
        value: "receipt_no",
        available: true,
        disabled: true,
      },
      { text: this.$t(`date`), value: "given_time", available: true },
      { text: this.$t(`donator`), value: "donator", available: true },
      {
        text: this.$t(`accepted_time`),
        value: "accepted_time",
        available: true,
      },
      { text: this.$t(`receiver`), value: "receiver", available: true },
      { text: this.$t(`total`), value: "total", available: true },
      {
        text: this.$t(`charged`),
        value: "is_charged",
        available: true,
        align: "center",
        disabled: true,
      },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
